import 'dayjs/locale/es';
import AppContext from './context/AppContext';
import routes from './routes';
import AuthVerification from './components/AuthVerification';
import UWEContext from './context/UWEContext';
import { UWEThemeProvider } from './context/UWEThemeContext';
import { DarkModeProvider } from './context/DarkModeContext';
import RouteSwitch from './components/RouteSwitch';
import initAppConfiguration from './hooks/initAppConfiguration';
import { AD_CLIENT_ID, APP_NAME, BACKEND, LDAP_ENABLED } from './constants';
import ModalContext from './context/ModalContext';
import { OpenCasesProvider } from './context/OpenCasesContext';
import { AuthProvider } from './context/AuthContext';
import { BootLoadingProvider } from './context/BootLoadingContext';
import { ErrorBoundaryWithRouter as ErrorBoundary } from './components/ErrorBoundary';
import ErrorFallback from './components/ErrorFallback';
import ChatApp from './views/ChatApp';
import { USE_AI } from './constants';
import { AuthConfigContextFromBackendProvider } from './context/AuthConfigContext';

localStorage.removeItem('sidebar:workpage-keys');

const ConfigurationProvider = initAppConfiguration({
  LOGO_SRC: `${BACKEND}/template-files/logo.png`, // "uwe_logo.svg",
  APP_NAME,
  AD_CLIENT_ID,
  LDAP_ENABLED,
});

function App() {
  let app = (
    <ErrorBoundary fallback={ErrorFallback}>
      <ConfigurationProvider>
        <BootLoadingProvider>
          <AuthConfigContextFromBackendProvider>
            <AuthProvider>
              <AppContexts>
                <UWEContext.Component>
                  {/* <OpenCasesProvider> */}
                  <AuthVerification />
                  {USE_AI && <ChatApp />}
                  <RouteSwitch routes={routes} />
                  {/* </OpenCasesProvider> */}
                </UWEContext.Component>
              </AppContexts>
            </AuthProvider>
          </AuthConfigContextFromBackendProvider>
        </BootLoadingProvider>
      </ConfigurationProvider>
    </ErrorBoundary>
  );

  app = <UWEThemeProvider>{app}</UWEThemeProvider>;
  app = <DarkModeProvider>{app}</DarkModeProvider>;

  return app;
}

function AppContexts({ children, auth }) {
  let element = children;
  element = <ModalContext.ProviderComponent>{element}</ModalContext.ProviderComponent>;
  element = <AppContext.Component>{element}</AppContext.Component>;

  return element;
}

export default App;
